import { roleManagerUrlEnvVar } from "@src/cloud-connect/feature-toggles/feature-toggles";
import { RolesDescriptions } from "@src/types/role-manager";
import axios, { isAxiosError } from "axios";

export const getRolesDescriptions = async () => {
  const url = roleManagerUrlEnvVar();

  try {
    const response = await axios.get<RolesDescriptions>(
      `${url}/api/v1/roles-detailed`,
    );
    return response;
  } catch (err) {
    if (isAxiosError(err)) {
      console.error("Axios error:", err);

      throw new Error(
        err.response?.data?.detail ||
          err.response?.data?.message ||
          "Failed to fetch users. Please try again later.",
      );
    } else {
      throw new Error("An unexpected error occurred while fetching users.");
    }
  }
};
